import Input from "../../../common/Input";

const Location = ({
	handleChange,
	values,
	touched,
	errors,
	setFieldTouched,
	isEdit,
	handleEditIconClick,
	handleBlur,
	editingField,
	isDisabled,
}) => {
	// const { handleChange, values, touched, errors, setFieldTouched } = formik;
	return (
		<div className="mb-3">
			<h2 className="text-black-lose text-[13px] font-medium mb-2">Location</h2>
			<div className="col-span-12">
				<Input
					placeholder="Enter"
					inputBox="mb-0"
					type="text"
					labelName="Google Map URL*"
					labelClassName="block text-primary-400 text-[13px] leading-[20px]"
					className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
					name="location.googleMapUrl"
					id="location.googleMapUrl"
					value={values?.location?.googleMapUrl}
					onChange={(e) => {
						handleChange(e);
						setFieldTouched("location.googleMapUrl", true, false);
					}}
					isError={
						touched?.location?.googleMapUrl &&
						Boolean(errors?.location?.googleMapUrl)
					}
					errorMessage={errors?.location?.googleMapUrl}
					disabled={isDisabled && editingField !== "location.googleMapUrl"}
					showEditIcon={isEdit}
					onBlur={() => (handleBlur ? handleBlur("location.googleMapUrl") : "")}
					onEditClick={() => handleEditIconClick("location.googleMapUrl")}
					disabledClass="bg-primary-50 border-primary-50 "
				/>
			</div>
		</div>
	);
};

export default Location;
